// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1y6Tu","footer":"ModalInfo_footer__1As_c"};